import ApplicationSerializer from './application';

export default class BlacklistFilterSerializer extends ApplicationSerializer {
  attrs = {
    createdBy: { serialize: false },
    createdByContext: { serialize: false },
    createdAt: { serialize: false },
    photo: { serialize: false }, // photo upload/delete is managed separately as an attachment
    permissions: { serialize: false }, // read-only authz envelope (BE-computed); never sent on write
  };
}
